import {
  FULL_SERVICE,
  GLOBAL_CATALOGS,
} from '../../types';

const initialState = {
  tabs: [],
  isLoading: false,
  announcement: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
  details: {},
};

const cleanReducer = function (state = initialState, action) {
  switch (action.type) {
    case FULL_SERVICE.Clean.Loading: {
      return {
        ...state,
        isLoading: action.payload
      };
    }
    case GLOBAL_CATALOGS.Clean.Service: {
      return {
        ...state,
        tabs: action.payload
      };
    }
    case GLOBAL_CATALOGS.Clean.Announcement.List: {
      return {
        ...state,
        announcement: { ...action.payload }
      };
    }
    default: {
      return state;
    }
  }
};

export default cleanReducer;
